import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

// Types
export interface PostNowPayload {
  platformContentMap: { [platform: string]: number }; // platform -> content_id
  restaurantId: string;
  flyerId?: number;
}

export interface PostNowResult {
  platform: string;
  success: boolean;
  error?: string;
}

interface PostNowState {
  loading: boolean;
  success: boolean;
  error: string | null;
  results: PostNowResult[];
}

const initialState: PostNowState = {
  loading: false,
  success: false,
  error: null,
  results: [],
};

const postNowSlice = createSlice({
  name: 'postNow',
  initialState,
  reducers: {
    postNowRequest: (state, _action: PayloadAction<PostNowPayload>) => {
      state.loading = true;
      state.success = false;
      state.error = null;
      state.results = [];
    },
    postNowSuccess: (state, action: PayloadAction<PostNowResult[]>) => {
      state.loading = false;
      state.success = true;
      state.results = action.payload;
    },
    postNowFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.success = false;
      state.error = action.payload;
    },
    postNowReset: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.results = [];
    },
  },
});

export const {
  postNowRequest,
  postNowSuccess,
  postNowFailure,
  postNowReset,
} = postNowSlice.actions;

export default postNowSlice.reducer;
